<div class="mailPreview" *ngIf="message" [class._unRead]="displayUnreadStatus && message.messageReceptionStatus !== 'READ'">
    <div class="mailPreview-header">
        <h2 class="mailPreview-header-subject">
            <i class="far fa-envelope" *ngIf="displayUnreadStatus && message.messageReceptionStatus !== 'READ'"></i>
            {{message.subject}}
        </h2>
        <span class="mailPreview-header-date">{{message.sentDate | date:'short':'':'fr-FR'}}</span>
        <span class="mailPreview-header-menu"><i class="fas fa-ellipsis-h" (click)="onDisplayMessage()"></i></span>
    </div>
    <span class="mailPreview-sender">{{message.author.person.firstName}} {{message.author.person.lastName}}</span>
    <div class="mailPreview-message" [innerHtml]="preview"></div>
</div>
